/**
 * Aufgabenoptionen, die in API, Oberfläche und Metarr gleich heißen.
 *
 * Cubic Projects hatte diese Listen mehrfach: im Zod-Schema, im Ticketdialog
 * und im Verknüpfungs-Picker. Studio hält die fachliche Auswahl an einer
 * Stelle. Die Datenbank speichert weiterhin nur den stabilen Wert.
 */
import { z } from "zod";
import { BEZIEHUNGEN, istSymmetrisch, } from "./kanten.js";
export const AUFGABEN_ARTEN = [
    "aufgabe",
    "fehler",
    "story",
    "verbesserung",
];
export const aufgabenartSchema = z.enum(AUFGABEN_ARTEN);
export const AUFGABEN_ART_LABEL = {
    aufgabe: "Aufgabe",
    fehler: "Fehler",
    story: "Story",
    verbesserung: "Verbesserung",
};
export const AUFGABEN_PRIORITAETEN = [0, 1, 2, 3];
export const AUFGABEN_PRIORITAET_LABEL = {
    0: "Keine Priorität",
    1: "Niedrig",
    2: "Mittel",
    3: "Hoch",
};
/**
 * Die kanonischen Aufgabenbeziehungen. Umkehrarten wie `folgt_auf` stehen
 * nicht ein zweites Mal in der Auswahl; die Richtung entscheidet, welche
 * Aufgabe Quelle und Ziel der einen gespeicherten Kante sind.
 */
export const AUFGABEN_BEZIEHUNGSARTEN = [
    "haengt_zusammen",
    "blockiert",
    "dupliziert",
    "ergaenzt",
    "loest_ab",
    "verursacht",
    "geht_voraus",
    "aufgeteilt_in",
    "geloest_durch",
];
export const aufgabenbeziehungsartSchema = z.enum(AUFGABEN_BEZIEHUNGSARTEN);
export const AUFGABEN_BEZIEHUNGSART_LABEL = {
    haengt_zusammen: "Beziehung",
    blockiert: "Abhängigkeit",
    dupliziert: "Duplikat",
    ergaenzt: "Ergänzung",
    loest_ab: "Ersetzung",
    verursacht: "Ursache",
    geht_voraus: "Reihenfolge",
    aufgeteilt_in: "Zuschnitt",
    geloest_durch: "Behebung",
};
export const AUFGABEN_BEZIEHUNGSRICHTUNGEN = [
    "aktuell_zu_anderer",
    "anderer_zu_aktuell",
];
export const aufgabenbeziehungsrichtungSchema = z.enum(AUFGABEN_BEZIEHUNGSRICHTUNGEN);
export const AUFGABEN_BEZIEHUNGSOPTIONEN = AUFGABEN_BEZIEHUNGSARTEN.map((art) => {
    const definition = BEZIEHUNGEN[art];
    return {
        art,
        label: AUFGABEN_BEZIEHUNGSART_LABEL[art],
        aussageAusgehend: definition.label,
        aussageEingehend: BEZIEHUNGEN[definition.umkehrung].label,
        symmetrisch: istSymmetrisch(art),
    };
});
/**
 * Richtet eine Auswahl auf die kanonische gespeicherte Beziehungsart aus.
 * Dadurch wird etwa "wird blockiert von" als umgedrehte `blockiert`-Kante
 * gespeichert und die Blockadeprüfung muss nicht zwei Schreibweisen kennen.
 */
export function richteAufgabenbeziehungAus(aktuelleId, andereId, art, richtung) {
    if (istSymmetrisch(art) || richtung === "aktuell_zu_anderer") {
        return { vonId: aktuelleId, nachId: andereId, art };
    }
    return { vonId: andereId, nachId: aktuelleId, art };
}
//# sourceMappingURL=aufgaben.js.map